// Single source of truth for the AI Eye Symptom Checker credit + disclaimer.
// Any surface that shows either string should import from here so we never
// drift between the wizard, SEO pages, admin, homepage and backend copies.

export const SC_CREDIT_LINE =
  "Concept by Dr. Shantanu Kumar Gupta & Dr. Manisha Mishra · Developed with AI";

export const SC_DISCLAIMER_SHORT =
  "This tool does not diagnose eye diseases. It provides educational guidance only and is not a replacement for a physical consultation by an ophthalmologist.";

export const SC_DISCLAIMER_LONG =
  "The AI Eye Symptom Checker is an educational triage aid only. It cannot examine your eye and it cannot make a diagnosis. It is not a substitute for a physical, in-person consultation with an ophthalmologist. If you have any doubt, please book an appointment or come to the clinic.";
